import { Routes } from "../../../../models/route.models";
import { ProfileDropdownItem } from "design-system";
//@ts-ignore
import UserAvatar from "@carbon/icons/es/user--avatar/16";
//@ts-ignore
import UserSettings from "@carbon/icons/es/user--settings/16";
//@ts-ignore
import Document from "@carbon/icons/es/document/16";
//@ts-ignore
import Logout from "@carbon/icons/es/logout/16";
//@ts-ignore
import DocumentProtected from "@carbon/icons/es/document--protected/16";
//@ts-ignore
import Cookie from "@carbon/icons/es/cookie/16";

export const RouteToTitleMap = {
	[Routes.LOGIN]: "Login",
	[Routes.SIGNUP]: "Signup",
	[Routes.DEMO]: "API App Playground",
	[Routes.DASHBOARD]: "Dashboard",
	[Routes.TAX_FREE]: "Retirement Savings Modeler",
	[Routes.VAR_APPLICATION]: "Value at Risk",
	[Routes.BROWN_HAM]: "Precipitate Dislocation Model from Brown and Ham",
	[Routes.BME680]: "BME680 Calibration Routines",
	[Routes.BATTERY_STATE]: "Battery State of Charge Estimation",
	[Routes.MLX]: "MLX90640 Temperature Sensor",
	[Routes.MOONFIRE]: "Moonfire Portfolio Modelling",
};

export const ProfileDropDownMenuItems: ProfileDropdownItem[] = [
	{
		label: "View Public Profile",
		link: "/profile",
		icon: UserAvatar,
		isDivider: false,
	},
	{
		label: "Profile Settings",
		link: "/settings",
		icon: UserSettings,
		isDivider: false,
	},
	{
		isDivider: true,
	},
	{
		label: "Service Agreement",
		link: "/service-agreement",
		icon: Document,
		isDivider: false,
	},
	{
		label: "Privacy Policy",
		link: "/privacy-policy",
		icon: DocumentProtected,
		isDivider: false,
	},
	{
		label: "Cookie Policy",
		link: "/cookie-policy",
		icon: Cookie,
		isDivider: false,
	},
	{
		isDivider: true,
	},
	{
		label: "Logout",
		link: "/logout",
		icon: Logout,
		isDivider: false,
	},
];
